import {TStore} from 'models';

export const selectToast = (state: TStore) => state?.toast?.data;
